<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Trazabilidad de documentos</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="cerrar()" id="btnrCerrarModal"
      (keydown.tab)="onChangeNextFocus('#btnrCerrarModal')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group col-md-12">
      <ol class="breadcrumb" *ngIf="!viewTrazabilidad">
        <li class="breadcrumb-item" style="font-size: 13px">{{tipdoc}}</li>
        <li class="breadcrumb-item" style="font-size: 13px">{{series}}</li>
        <li class="breadcrumb-item" style="font-size: 13px">{{numdoc}}</li>
      </ol>

      <div class="card">
        <div class="card-body" style="padding: 0px;">
          <ngb-tabset>
            <ngb-tab>
              <ng-template ngbTabTitle> <span (click)="clickTabTrazabilidad()" >Trazabilidad</span>
              </ng-template>
              <ng-template ngbTabContent>

                <br>
           

                <hr>
                <div class="table-responsive">
                  <table class="table table-sm table-striped table-bordered m-t-15 table-hover"
                    id="ModalDatatableTrazabilidad" cellspacing="0">
                    <thead>
                      <tr>
                        <th class="text-center"> </th>
                        <th class="text-center"><i class="fas fa-bullseye"></i> </th>
                        <th style="white-space: nowrap;"> #Interno </th>
                        <th> Serie </th>
                        <th> Número </th>
                        <th> T. Documento </th>
                        <!-- <th> Documento </th> -->
                       
                        <th style="white-space: nowrap;"> F. Emisión </th>
                        <th> Situación </th>

                        <th> C.Cliente </th>
                        <th> Razón social </th>
                        <th> C. Pago </th>
                        <th> Importe </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="cursor" *ngFor="let lst of trazabilidades">

                        <td class="text-center">
                          <input [checked] ="lst == docSeleccionado" type="radio" (change)="onSelectItem(lst)" tabindex="13" name="radio">
                        </td>
                        <td style="text-align: center;">

                          <div class="btn-group dropright" ngbDropdown container="body" role="group"
                            aria-label="Button group with nested dropdown" style="margin: 0px; padding: 0px;">
                            <button class="btn btn-sm" ngbDropdownToggle style="margin: 0px; padding: 0px;">
                              <i class=" fas fa-align-left"></i>
                            </button>
                            <div class="dropdown-menu" ngbDropdownMenu>
                              <!--COTIZACION-->
                              <div *ngIf="lst.tipdoc == 100">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'A4SinDescuento')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'A4ConDescuento')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4 con
                                  descuentos</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'TICKET')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir ticket
                                </button>
                              </div>

                              <!--ORDEN PEDIDO-->
                              <div *ngIf="lst.tipdoc == 101">
                                <button class="dropdown-item" (click)="downloadPDFFormato1(lst)"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFFormato2(lst)"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4 con códigos
                                  adicionales</button>
                              </div>

                              <!--GUIA DE REMISION-->
                              <div *ngIf="lst.tipdoc == 102">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'TICKET')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir
                                  ticket</button>
                              </div>


                              <!--FACTURA-->
                              <div *ngIf="lst.tipdoc == 1">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'TICKET')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir
                                  Ticket</button>
                              </div>

                              <!--BOLETA-->
                              <div *ngIf="lst.tipdoc == 3 ">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'TICKET')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir
                                  Ticket</button>
                              </div>

                              <!--NOTA DE CREDITO-->
                              <div *ngIf="lst.tipdoc == 7">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'TICKET')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir
                                  Ticket</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>

                              </div>

                              <!--NOTA DE DEBITO-->
                              <div *ngIf="lst.tipdoc == 8">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'TICKET')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir
                                  Ticket</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst, 'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>

                              </div>

                              <!--ANTICIPO-->
                              <div *ngIf="lst.tipdoc == 9">
                                <button class="dropdown-item"><i class="fa fa-print font-14"
                                    style="margin-right: .3rem"></i>
                                  En desarrollo...</button>
                              </div>

                              <!--GUIA INTERNA-->
                              <div *ngIf="lst.tipdoc == 103">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4CalidadColor')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4 con calidad
                                  y color</button>
                              </div>


                              <!--ORDEN DE COMPRA-->
                              <div *ngIf="lst.tipdoc == 105">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4CalidadColor')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4 con calidad
                                  y color</button>

                              </div>

                              <!--GUIA DE RECEPCION-->
                              <div *ngIf="lst.tipdoc == 108">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'Imprimir')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir
                                </button>

                              </div>

                              <!--DOCUMENTO DE IMPORTACION-->
                              <div *ngIf="lst.tipdoc == 115">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4CalidadColor')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4 con calidad y color</button>

                              </div>

                              <!--REQUERIMIENTO DE COMPRA-->
                              <div *ngIf="lst.tipdoc == 125">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4</button>
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4CalidadColor')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir A4 con calidad
                                  y color</button>

                              </div>

                              <!--RECIBO-->
                              <div *ngIf="lst.tipdoc == 210">
                                <button class="dropdown-item" (click)="downloadPDFReporte(lst,'A4CodigosAdicionaes')"><i
                                    class="fa fa-print font-14" style="margin-right: .3rem"></i> Imprimir
                                  ticket</button>
                              </div>

                            </div>

                          </div>

                        </td>
                        <td style="text-align: center;">{{lst.numint}}</td>
                        <td>{{lst.series}}</td>
                        <td>{{lst.numdoc}}</td>
                        <!-- <td>{{lst.tipdoc}}</td> -->
                        <td style="white-space: nowrap;">{{lst.destipdoc}}</td>
                      
                        <td style="white-space: nowrap;">{{lst.femisi | date:'dd/MM/yyyy'}}</td>
                        <td style="white-space: nowrap;">{{lst.dessit}}</td>
                        <td>{{lst.codcli}}</td>
                        <td style="white-space: nowrap;">{{lst.razonc}}</td>
                        <td style="white-space: nowrap;">{{lst.descpag}}</td>
                        
                        <td style="text-align: right">{{lst.preven | number:'.2-2'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </ng-template>
            </ngb-tab>

            <!--<ngb-tab *ngIf=tabseleccionado>
              <ng-template ngbTabTitle> <span>Archivos Adjuntos</span>
              </ng-template>
              <ng-template ngbTabContent>

                <div class="table-responsive">
                  <table class="table table-sm table-striped table-bordered m-t-15 table-hover"
                    id="ModalDatatableDatosAdjuntos" cellspacing="0">
                    <thead>
                      <tr>
                        <th> Descargar </th>
                        <th> Item </th>
                        <th> Formato </th>
                        <th> Nombre </th>
                        <th> Observación </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="cursor" *ngFor="let lst of datosAdjuntos">
                        <td style="text-align: center">
                          <button (click)="downloadDatosAdjuntos(lst)" class="btn btn-default btn-xs m-r-5"
                            data-toggle="tooltip"><i class="fa fa-download"></i></button>
                        </td>
                        <td style="text-align: right;">{{lst.item}}</td>
                        <td style="text-align: left;">{{lst.formato}}</td>
                        <td style="text-align: left;">{{lst.nombre}}</td>
                        <td style="text-align: left;">{{lst.observ}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </ng-template>
            </ngb-tab>-->

            <ngb-tab *ngIf=tabseleccionado>
              <ng-template ngbTabTitle> <span>Registro de transacciones</span>
              </ng-template>
              <ng-template ngbTabContent>
                <div class="table-responsive">
                  <table class="table table-sm table-striped table-bordered m-t-15 table-hover"
                    id="ModalDatatableLogTransacciones" cellspacing="0">
                    <thead>
                      <tr>
                        <th> # Interno </th>
                        <th> T.Docu </th>
                        <th> Comprobante </th>
                        <th> Serie </th>
                        <th> Número </th>
                        <th> Emisión </th>
                        <th> Situación </th>
                        <th> Creación </th>
                        <th> Código </th>
                        <th> Usuario </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="cursor" *ngFor="let lst of logTranzacciones">
                        <td style="text-align: center;">{{lst.numint}}</td>
                        <td style="text-align: left;">{{lst.tipdoc}}</td>
                        <td style="text-align: left;">{{lst.destipdoc}}</td>
                        <td style="text-align: left;">{{lst.series}}</td>
                        <td style="text-align: left;">{{lst.numdoc}}</td>
                        <td style="text-align: right;">{{lst.femisi | date:'dd/MM/yyyy'}}</td>
                        <td style="text-align: left;">{{lst.dessit}}</td>
                        <td style="text-align: left;">{{lst.fcreac | date:'dd/MM/yyyy, h:mm a'}}</td>
                        <td style="text-align: left;">{{lst.usuari}}</td>
                        <td style="text-align: left;">{{lst.nombres}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-template>
            </ngb-tab>

          </ngb-tabset>

        </div>
      </div>

    </div>
  </div>
</div>